import React, { useState, useEffect } from 'react';
import { Router, Switch, Redirect } from 'react-router-dom';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import Loadable from 'react-loadable';
import Modal from '@material-ui/core/Modal';
import mousetrap from 'mousetrap';

import Route from 'components/Route';
import theme from 'meta/theme';
import { history, oauthURL } from 'meta/constants';
import HomePage from 'pages/Home';
import NotFound from 'pages/NotFound';
import OAuthPage from './OAuthPage';
import OldSchoolBotIndexPage from './OldSchoolBot/Index';
import Loading from './Loading';
import ResponsiveButton from 'components/ResponsiveButton';
import Swamp from 'resources/images/swamp.png';

const CluePage = Loadable({
	loader: () => import('./CluePage'),
	loading: Loading
});

// const HiscoresPage = Loadable({
// 	loader: () => import('./Hiscores'),
// 	loading: Loading
// });

const RaidsSimulatorPage = Loadable({
	loader: () => import('./RaidsSimulator'),
	loading: Loading
});

const AccountPage = Loadable({
	loader: () => import('./Account'),
	loading: Loading
});

const WowPage = Loadable({
	loader: () => import('./Wow'),
	loading: Loading
});

const MonstersPage = Loadable({
	loader: () => import('./Monsters'),
	loading: Loading
});

interface Egg {
	trigger: string;
	image: string;
	audio: string;
}
const Eggs = [
	{
		trigger: 's w a m p l e t i c s',
		image: Swamp,
		audio: `https://cdn.discordapp.com/attachments/357422607982919680/749297267109920828/swampletics.mp3`
	}
];

const Root = () => {
	const [selectedEgg, setSelectedEgg] = useState<Egg | null>(null);
	useEffect(() => {
		for (const egg of Eggs) {
			mousetrap.bind(egg.trigger, () => setSelectedEgg(egg));
		}
		return () => {
			for (const egg of Eggs) {
				mousetrap.unbind(egg.trigger);
			}
		};
	});
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />

			<Modal open={Boolean(selectedEgg)} onClose={() => setSelectedEgg(null)}>
				{selectedEgg ? (
					<>
						<ResponsiveButton file={selectedEgg!.audio} />
						<img
							src={selectedEgg?.image}
							style={{
								imageRendering: 'pixelated',
								width: '100vw',
								objectFit: 'fill',
								zIndex: 1
							}}
							alt=""
						/>
					</>
				) : (
					<div></div>
				)}
			</Modal>

			<Router history={history}>
				<Switch>
					<Route exact path="/" component={HomePage} />
					<Route path="/clues" component={CluePage} />
					{/* <Route path="/hiscores" component={HiscoresPage} /> */}
					<Route path="/raids" component={RaidsSimulatorPage} />
					<Route path="/monsters" component={MonstersPage} />
					<Route path="/oldschoolbot/:slug?" component={OldSchoolBotIndexPage} />
					<Route path="/oauth/callback" component={OAuthPage} />
					<Route authenticated path="/account" component={AccountPage} />
					<Route path="/wow" component={WowPage} />

					<Route
						path="/login"
						render={() => {
							window.location.replace(oauthURL.toString());
							return null;
						}}
					/>
					<Redirect from="/commands" to="/oldschoolbot/commands" />
					<Route component={NotFound} />
				</Switch>
			</Router>
		</ThemeProvider>
	);
};

export default Root;
